module.exports = __webpack_public_path__ + "3013c0d156661bdb25efc385b6c2eaaf.svg";